/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { SmoothLink } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

class PageMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdown: false,
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.addWrapperRef = this.addWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  toggleDropdown(e) {
    e.preventDefault();

    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  closeDropdown() {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect();
    }

    this.setState({
      dropdown: false,
    });
  }

  addWrapperRef(node) {
    if (!this.wrapperRefs) {
      this.wrapperRefs = [];
    }
    this.wrapperRefs.push(node);
  }

  handleClickOutside(event) {
    if (this.wrapperRefs && !this.wrapperRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeDropdown();
    }
  }

  render() {
    const { title, items, match } = this.props;
    const { dropdown } = this.state;

    return (
      <div className="page-menu-wrapper clearfix">
        <a href="" className="page-menu-mobile-btn" ref={this.addWrapperRef} onClick={this.toggleDropdown}>{title}</a>
        <ul className={`page-menu ${dropdown ? 'open' : ''}`} ref={this.addWrapperRef}>
          {
            items.map(item => {
              if (item.hide) {
                return null;
              }

              if (item.name) {
                return (
                  <li key={item.name} onClick={this.closeDropdown}>
                    <Link
                      name={item.name}
                      keepParams={item.keepParams}
                    >
                      {item.title}
                    </Link>
                  </li>
                );
              } else if (item.id) {
                return (
                  <li key={item.id} onClick={this.closeDropdown}>
                    <SmoothLink
                      href={item.id}
                    >
                      {item.title}
                    </SmoothLink>
                  </li>
                );
              }

              return (
                <li key={item.path} onClick={this.closeDropdown}>
                  <a
                    href={item.path}
                    className={`${(match.path === item.path) ? 'active' : ''}`}
                  >
                    {item.title}
                  </a>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}

PageMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  match: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};

PageMenu.defaultProps = {
  items: [],
  onSelect: undefined,
};

export default withRouter(PageMenu);



// WEBPACK FOOTER //
// ./src/components/PageMenu/index.js